import { Link } from 'react-router-dom'
import netzence from '../../images/Frame 2147228713.png'
import image1 from '../../images/datawithSS.png'
import image2 from '../../images/sus2.png'
import image3 from '../../images/sus1.png'
import Header from '../shared/Header'
import Footer from '../shared/Footer'
import sportlight from '../../images/traffic.png'
import { useEffect } from 'react'

function BlogPost4() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  const blogs = [
    {
      id: 1,
      badge: "Clean Transport",
      badgeColor: "#006633",
      title: "Netzence set to unveil clean mobility hailing App in June 2026",
      description: "At a time when Nigeria’s cities are expanding at an unprecedented pace, and the strain on urban systems is becoming increasingly visible, e, a quiet but critical shift is beginning to take shape...",
      source: "25/03/2026",
      image: image1,
      readMoreLink: "/blogpost"
    },
    {
      id: 2,
      badge: "Clean Transport",
      badgeColor: "#006633",
      title: "Introducing Low-cost mobility for Nigeria’s transport system  Netzence",
      description: "Nigeria’s mobility ecosystem is undergoing a profound shift. Rising fuel prices, worsening congestion, and growing urban populations ",
      source: "28/12/2025",
      image: image2,
      readMoreLink: "/blogpost1"
    },
    {
      id: 3,
      badge: "Global Footprint Network",
      badgeColor: "#00AED9",
      title: "Netzence partners with Ministry of Livestock, Germany’s GIZ to conduct livestock monitoring capacity-building",
      description: "Netzence Sustainability Limited (Netzence) has taken a significant step toward strengthening...",
      source: "30/12/2025",
      image: image3,
      readMoreLink: "/blogpost2"
    }
  ];

  return (
    <>
      <Header />

      {/* Return to blog */}
      <Link to="/blogs">
        <div className='ml-4 mr-4 sm:ml-8 sm:mr-8 md:ml-16 md:mr-16 lg:ml-32 lg:mr-32 xl:ml-72 xl:mr-72 text-[14px] flex pt-20'>
          Return to blog
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.5 18L15.5 12L9.5 6" stroke="#898989" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </Link>

      {/* Title */}
      <div className='ml-4 mr-4 sm:ml-8 sm:mr-8 md:ml-16 md:mr-16 lg:ml-32 lg:mr-32 xl:ml-72 xl:mr-72 text-[20px] sm:text-[22px] md:text-[24px] font-bold mt-2'>
        2026 Climate Mobility Horizon: Nigeria’s New Income Engine – Netzence
      </div>

      {/* Author row */}
      <div className='ml-4 mr-4 sm:ml-8 sm:mr-8 md:ml-16 md:mr-16 lg:ml-32 lg:mr-32 xl:ml-72 xl:mr-72 flex gap-5 mt-10'>
        <img loading='lazy' src={netzence} alt="netzence" className='w-[48px] h-[48px] object-contain flex-shrink-0' />

        <div>
          <div className='text-[16px] mb-3'>
            Netzence
          </div>
          <div className='flex items-center gap-3 text-[14px] sm:text-[15px] md:text-[16px]'>
            January 6, 2026
            <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="3" cy="3" r="3" fill="#898989"/>
            </svg>
            7 mins read
          </div>
        </div>
      </div>

      {/* Hero image */}
      <div className='mt-20 px-4 sm:px-8 md:px-16 lg:px-32 xl:ml-72 xl:mr-72 xl:px-0'>
        <img loading='lazy' src={sportlight} alt="spotlight" className='w-full max-w-[1200px] object-cover rounded-lg' />
      </div>

      {/* Body content */}
      <div className='mt-20 px-4 sm:px-8 md:px-16 lg:px-32 xl:ml-72 xl:px-0'>
        <div className="flex flex-col items-start gap-4 w-full max-w-[1152px] h-auto">
          {/* Paragraph 1 */}
          <p className="text-[#3B3B3B] font-normal text-[15px] sm:text-[16px] md:text-[17px] lg:text-[18px] leading-[26px] sm:leading-[27px] md:leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
Nigeria is facing a potential silent public-health emergency – one that does not announce itself with sirens or breaking news alerts, but with chronic coughs, shortened lifespans, and overstretched hospitals. Across Lagos, Kano, Port Harcourt, Aba, and Abuja, toxic smog from traffic fumes, diesel generators, industrial emissions, open waste burning, and dust has become an everyday reality. Netzence Sustainability Limited (Netzence) has pioneered a technological solution that turns everyday transport decisions into verifiable economic value. Rather than treating pollution as an unavoidable side effect of human life, the company measures emissions reductions from ride-pooling, eco-routing, fuel-efficient driving, the adoption of compressed natural gas (CNG), and the use of low-emission and electric vehicles, transforming those reductions into tradable carbon credits. According to Associate Professor Sadiq Sani, Founder and Chief Executive Officer of Netzence, “every commute will be translated into earnings and sustainability practices for a better life and economic development”. Through its technological solution, supported by its CloseCarbon technology stack, transport system data is measured and captured in real time, verified against recognised standards, and converted into measurable climate assets.      </p>

          {/* Paragraph 2 */}
          <p className="text-[#3B3B3B] font-normal text-[15px] sm:text-[16px] md:text-[17px] lg:text-[18px] leading-[26px] sm:leading-[27px] md:leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
These assets can then be monetised, with value returned directly to commuters, drivers, and fleet operators, thereby supporting the advancement of local and international carbon markets for every individual and organisation. “If avoidable emissions are actively reduced on Nigerian roads every day, then people should earn the value of those reductions. Our role is to make that value verifiable, visible, and payable,” said Associate Professor Sadiq Sani.      </p>

          {/* Paragraph 3 */}
          <p className="text-[#3B3B3B] font-normal text-[15px] sm:text-[16px] md:text-[17px] lg:text-[18px] leading-[26px] sm:leading-[27px] md:leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
According to the World Health Organisation, air pollution contributes to over 114,000 premature deaths annually in Nigeria, placing it among the country’s most severe environmental health risks. The World Bank estimates that pollution-related illness and lost productivity cost the Nigerian economy more than $6 billion each year. In Lagos, roadside air pollution levels regularly exceed safe limits by three to five times, while Port Harcourt’s long-running soot crisis and Kano’s rising vehicular density continue to worsen respiratory and cardiovascular outcomes.      </p>

          {/* Paragraph 4 */}
          <p className="text-[#3B3B3B] font-normal text-[15px] sm:text-[16px] md:text-[17px] lg:text-[18px] leading-[26px] sm:leading-[27px] md:leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
“Air pollution is often discussed as a health issue, but in Nigeria it is just as much an economic crisis,” said Idia Ogedegbe, Chief Operations Officer of Netzence.      </p>

          {/* Paragraph 5 */}
          <p className="text-[#3B3B3B] font-normal text-[15px] sm:text-[16px] md:text-[17px] lg:text-[18px] leading-[26px] sm:leading-[27px] md:leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
“When workers are sick, productivity drops. When families spend more on transport and healthcare, disposable income disappears. Clean mobility is not a luxury – it is an economic stabiliser.”      </p>

          {/* Paragraph 6 */}
          <p className="text-[#3B3B3B] font-normal text-[15px] sm:text-[16px] md:text-[17px] lg:text-[18px] leading-[26px] sm:leading-[27px] md:leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
At the centre of this crisis sits Nigeria’s transport system.      </p>

          {/* Paragraph 7 */}
          <p className="text-[#3B3B3B] font-normal text-[15px] sm:text-[16px] md:text-[17px] lg:text-[18px] leading-[26px] sm:leading-[27px] md:leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
From the smoke-belching danfo buses of Lagos to the congested arterial roads of Kano, from diesel trucks servicing Port Harcourt’s industrial corridors to the gridlocked commercial streets of Aba, transport has become one of the largest contributors to urban air pollution – and one of the heaviest financial burdens on households. Daily commuting costs now routinely range between ₦2,000 and ₦4,000 in major cities. For many urban families, monthly transport expenses exceed ₦40,000, rivalling food costs and eroding household resilience. Yet within this challenge lies one of Nigeria’s most overlooked economic opportunities – clean mobility linked to climate finance. The benefits are already becoming visible. Drivers optimising routes and reducing idle time are recording fuel savings of 20–35 per cent, while riders using shared trips are cutting fares by up to 40 per cent. In cities like Abuja and Lagos, pooled mobility and route optimisation are lowering congestion pressure and shortening commute times-improvements that translate directly into economic productivity.      </p>

          {/* Paragraph 8 */}
          <p className="text-[#3B3B3B] font-normal text-[15px] sm:text-[16px] md:text-[17px] lg:text-[18px] leading-[26px] sm:leading-[27px] md:leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
The public-health impact is equally compelling. Medical studies show that reducing fine particulate matter (PM2.5) by just 10 micrograms per cubic metre can lower hospital admissions for respiratory illness by more than 15 per cent. In Port Harcourt, where soot pollution has plagued residents for years, transport emissions remain a major contributor during peak traffic hours. In Kano, rising vehicle volumes have been linked to increased childhood asthma rates, while Aba’s dense transport corridors record some of the highest roadside pollution levels in southern Nigeria.      </p>

          {/* Paragraph 9 */}
          <p className="text-[#3B3B3B] font-normal text-[15px] sm:text-[16px] md:text-[17px] lg:text-[18px] leading-[26px] sm:leading-[27px] md:leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
Reduced congestion lowers some health risk factors, cleaner air eases pressure on public hospitals, and lower transport costs free household income for education, nutrition, and small business growth. Clean mobility, in this sense, becomes not only an environmental intervention, but a tool for economic inclusion. “When citizens save money, breathe cleaner air, and earn from better transport choices, sustainability stops being abstract. It becomes personal, practical, and profitable. Clean mobility aligns climate goals with real economic relief,” Ogedegbe explained.      </p>

          {/* Paragraph 10 */}
          <p className="text-[#3B3B3B] font-normal text-[15px] sm:text-[16px] md:text-[17px] lg:text-[18px] leading-[26px] sm:leading-[27px] md:leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
From Lagos markets to Kano’s industrial routes, from Port Harcourt’s highways to Aba’s trading hubs, Nigeria’s streets are quietly becoming climate assets. Every ride, every route, every cleaner fuel choice now carries measurable value—value that cleans the air and puts money back where it belongs: in the pockets of Nigerians.      </p>

          {/* Paragraph 11 */}
          <p className="text-[#3B3B3B] font-normal text-[15px] sm:text-[16px] md:text-[17px] lg:text-[18px] leading-[26px] sm:leading-[27px] md:leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
Pollution has taken enough. With data, technology, and smart incentives, Nigeria can begin to take something back – one verified trip at a time.      </p>
        </div>
      </div>

      {/* Related Blogs heading */}
      <div className='mt-20 px-4 sm:px-8 md:px-16 lg:px-32 xl:ml-72 xl:px-0'>
        <h2
          className="text-[#0D924F] font-bold text-[26px] sm:text-[30px] md:text-[36px] leading-[1.2] md:leading-[43px]"
          style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}
        >
          Related Blogs
        </h2>
      </div>

      {/* Related Blogs cards */}
      <div className='mt-20 px-4 sm:px-8 md:px-16 lg:px-32 xl:ml-72 xl:px-0'>
        <div className='flex flex-col md:flex-row flex-wrap items-stretch justify-center md:justify-start gap-6 md:gap-8 mb-20'>
          {blogs.map((blog) => (
            <div
              key={blog.id}
              className="flex flex-col items-center pb-6 gap-4 w-full max-w-[379px] md:w-[379px] h-auto md:h-[544px] bg-white shadow-[0px_8px_24px_rgba(149,157,165,0.2)] rounded-2xl mx-auto md:mx-0 md:shrink-0"
            >
              {/* Image */}
              <div className="w-full h-[220px] sm:h-[250px] md:h-[282px] rounded-t-2xl overflow-hidden">
                <img
                  src={blog.image}
                  alt={blog.title}
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Article Content */}
              <div className="flex flex-col items-start gap-4 w-[90%] md:w-[352px] h-auto md:h-[222px]">
                {/* Badge */}
                <div
                  className="flex flex-row justify-center items-center px-1.5 py-0.5 gap-2 h-[25px] rounded max-w-full"
                  style={{ backgroundColor: blog.badgeColor }}
                >
                  <span
                    className="text-white font-medium text-[13px] md:text-[14px] leading-[21px] truncate"
                    style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}
                  >
                    {blog.badge}
                  </span>
                </div>

                {/* Text Container */}
                <div className="flex flex-col items-start gap-3 w-full">
                  {/* Title */}
                  <h3
                    className="text-[#3B3B3B] font-semibold text-[15px] sm:text-[17px] md:text-[20px] leading-[22px] md:leading-[24px] tracking-[-0.02em] w-full"
                    style={{
                      fontFamily: "'Inter', sans-serif",
                      fontFeatureSettings: "'cv01' on, 'cv03' on, 'cv04' on"
                    }}
                  >
                    {blog.title}
                  </h3>

                  {/* Description */}
                  <p
                    className="text-[#898989] font-normal text-[13px] md:text-[14px] leading-[20px] w-full"
                    style={{
                      fontFamily: "'Inter', sans-serif",
                      fontFeatureSettings: "'cv03' on, 'cv04' on"
                    }}
                  >
                    {blog.description}
                  </p>
                </div>

                {/* Footer */}
                <div className="flex flex-row justify-between items-center w-full">
                  <span
                    className="text-[#3B3B3B] font-normal text-[13px] md:text-[14px] leading-[21px]"
                    style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}
                  >
                    {blog.source}
                  </span>

                  <a
                    href={blog.readMoreLink}
                    className="flex flex-row justify-center items-center gap-2 transition-all duration-150 hover:opacity-80 group"
                  >
                    <span
                      className="text-[#006633] font-medium text-[13px] md:text-[14px] leading-[20px]"
                      style={{ fontFamily: "'Inter', sans-serif" }}
                    >
                      Read More
                    </span>
                    <div className="relative w-2.5 h-4 flex items-center justify-center">
                      <svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.5 1L6.5 6L1.5 11" stroke="#006633" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </>
  )
}

export default BlogPost4